// env vars from the cli are always strings, so !!ENV_VAR returns true for "false"
function bool(value) {
  if (value == null) return false;
  return value && value !== "false" && value !== "0";
}

import * as if_true from "chalk-BABEL_8_BREAKING-true";
import * as if_false from "chalk-BABEL_8_BREAKING-false";

export const { Chalk } = bool(process.env["BABEL_8_BREAKING"]) ? if_true : if_false;
export default (bool(process.env["BABEL_8_BREAKING"]) ? if_true : if_false).default;
